import { Button } from "@material-ui/core";
import { useState } from "react";
import { AdviceDelivery } from "../../../../api";
import { ReactComponent as LogoImage } from "../../../../images/nz-funds-nz-logo.svg";
import { useAppSelector } from "../../../../store";
import { Colors, TitleText } from "../../../controls/helpers";
import { Body, Hero } from "../../GridLayout";
import QuestionnaireScreen from "../../QuestionnaireScreen";

const StrongReturnsKiwiSaver = () => {
  const { adviceDelivery } = useAppSelector((state) => state.clientQuestionnaires);
  const [goToLearnMore, setGoToLearnMore] = useState(false);

  return (
    <QuestionnaireScreen hidePrev={adviceDelivery === AdviceDelivery.InPerson} overrideNextPageRoute={() => (goToLearnMore ? "learn-more" : "begin-questions")}>
      <Hero isNarrowView product="NzFunds">
        <LogoImage fill={Colors.White} />
      </Hero>
      <Body isNarrowView>
        <TitleText>NZ Funds is New Zealand owned and has been managing New Zealanders’ savings for over 33 years.</TitleText>
        <Button type="submit" onClick={(_) => setGoToLearnMore(true)} color="default" variant="contained" fullWidth>
          Learn more about NZ Funds
        </Button>
      </Body>
    </QuestionnaireScreen>
  );
};

export default StrongReturnsKiwiSaver;
